import React from 'react'
import PanelHead from '../../Panel/PanelHead'
import PanelBody from '../../Panel/PanelBody'
import { FormAddShop } from './FormAddShop'

export const PanelAddShop = () => {
    return (
        <div>  <PanelHead title='Add Advertising' />
            <PanelBody content={<FormAddShop />} />
        </div>


    )
}
